import authHeader from '@/backend/auth/auth-header'
import { useAxiosCreate } from '@/backend/utils'

const api = useAxiosCreate('trips')

export function checkKonturXml(tripId) {
  return api.get(`${tripId}/kontur/check`, { headers: authHeader() }).then((response) => response.data)
}

export function downloadKonturXml(tripId) {
  return api.get(`${tripId}/kontur/xml`, { headers: authHeader(), responseType: 'blob' })
}
